export type ResourceKind = 'skill' | 'teammate' | 'team'

export type RoutineStatus = {
  resource?: ResourceKind
  id?: string
  dirty: boolean
}

export type PageRoutine<TDraft = unknown> = {
  status: () => RoutineStatus
  save?: () => Promise<{ id: string }>
  discard?: () => Promise<void>
  requestDelete?: () => Promise<void>
  fetchDraft?: () => Promise<TDraft>
}

export type RoutineSource = () => PageRoutine

export type RoutineFailure = 'validation' | 'conflict' | 'permission' | 'cancelled' | 'unsupported' | 'error'

export class RoutineError extends Error {
  readonly reason: RoutineFailure

  constructor(reason: RoutineFailure, message: string) {
    super(message)
    this.name = 'RoutineError'
    this.reason = reason
  }
}

export function routineFailureReason(error: unknown): RoutineFailure {
  return error instanceof RoutineError ? error.reason : 'error'
}
